import React from "react";
import {Checkbox} from "../../form/checkbox/checkbox";
import Button from "../../button/button";
import PrintIcon from "../../../images/icons/print.svg";
import {Modal} from "../../modal/modal";
import {withTranslation} from "../../../i18n/translate";
import {
    filterProductParameterGroupsByProductDatabase,
    filterProductParameterGroupsByProducts, sortProductsByProductParameterGroup
} from "../product-param-helpers";
import {print} from "../../../util/print";
import LoadingSpinner from "../../loading-spinner/loading-spinner";

import './product-table-print-modal.sass'

class ProductTablePrintModal extends React.Component {
    constructor(props) {
        super(props);

        this.onUpdateHandle = this.props.productsDatabase.onUpdate(() => {
            this.setState(this.calculateNewState())
        })

        this.state = {
            ...this.calculateNewState(),
            loading: false,
        }
    }

    componentWillUnmount() {
        this.onUpdateHandle.unsubscribe()
    }

    calculateNewState() {
        const filteredProducts =
            this.props.productsDatabase.getFilteredProducts() || []
        const productParamGroups = filterProductParameterGroupsByProductDatabase(
            filterProductParameterGroupsByProducts(
                this.props.productParamGroups.filter((group) => !group.hidden),
                filteredProducts,
            ),
            this.props.productsDatabase,
        )

        this.productParamGroups = productParamGroups
        const printIncludedColumns = this.state
            ? this.state.printIncludedColumns
            : []

        return {
            filteredProducts,
            productParamGroups,
            printIncludedColumns,
        }
    }

    onModalCheck(index, val) {
        const { printIncludedColumns } = this.state
        printIncludedColumns[index] = val

        this.setState({ printIncludedColumns })
    }

    closeModal() {
        this.setState({ printModal: false })
    }

    onModalPrint() {
        this.closeModal();
        this.print();
    }

    print() {
        this.setState({loading: true});

        const printProductParamGroups = [];
        this.state.printIncludedColumns.forEach((included, index) => {
            if (included) {
                printProductParamGroups.push(this.state.productParamGroups[index].strapiId);
            }
        })

        const params = new URLSearchParams();

        params.set('cols', JSON.stringify(printProductParamGroups));

        print(`${this.props.path}print/?${encodeURI(params.toString())}`).then(() => {
            this.setState({loading: false});
            this.props.onClose();
        });
    }

    render() {
        const {t, onClose} = this.props;


        return <>
            <Modal shown={true} onClose={onClose}>
                <b>
                    {t("PRODUCTS-SELECT_COLUMNS_TO_PRINT")} (
                    {this.state.printIncludedColumns.filter((a) => !!a).length}/5)
                </b>

                <div style={{ padding: "1rem 0" }}>
                    {this.state.productParamGroups.map((group, index) => {
                        return (
                            <Checkbox
                                key={"option_" + index}
                                disabled={
                                    this.state.printIncludedColumns.filter((a) => !!a).length >=
                                    5 && !this.state.printIncludedColumns[index]
                                }
                                translatedLabel={`${group.type === "EFFECT" ? t("PRODUCTS-PRODUCT_FILTERS-EFFECT_COLON") : ""}${(group.name ? t(group.name.key) : "")}`}
                                checked={!!this.state.printIncludedColumns[index]}
                                onChange={(checked) => this.onModalCheck(index, checked)}
                            />
                        )
                    })}
                </div>

                <div className="_fp-product-table-print-modal__button-row">
                    <Button
                        buttonStyle={
                            (this.state.printIncludedColumns.filter((a) => !!a).length > 5 || this.state.loading)
                                ? "disabled"
                                : "green"
                        }
                        buttonSvgIconComponent={<PrintIcon />}
                        buttonCallback={() => this.onModalPrint()}
                        buttonLabel={t("GLOBAL-PRINT")}
                    />

                    {this.state.loading && <LoadingSpinner/>}
                </div>
            </Modal>
        </>
    }
}

export default withTranslation()(ProductTablePrintModal);